import React from 'react'
import styled from 'styled-components'
import { breakpointUpTo } from 'utils/breakpoints'

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.space[4]} 30.5px;
  display: inline-block;
  border: 4px solid rgba(26, 26, 26, 0.06);
  width: 100%;
  box-sizing: border-box;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    padding: ${({ theme }) => theme.space[4]};
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    padding: 18px;
  }
`
const InnerWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.grey};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 209px;
  svg {
    width: 100%;
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    height: 153px;
    svg {
      max-width: calc(100% - 20px);
      max-height: 80%;
    }
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    height: 110px;
  }
`

const StyledImg = styled.img`
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
`

export type BrandCarouselItemProps = {
  alt: string
  image: string
}
export const BrandCarouselItem = ({ alt, image }: BrandCarouselItemProps) => (
  <Wrapper>
    <InnerWrapper>
      <StyledImg src={image} alt={alt} />
    </InnerWrapper>
  </Wrapper>
)
